import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { ChevronRight, BookOpen, ArrowLeft, Search, ChevronDown, TrendingUp, TrendingDown } from 'lucide-react';
import AuroraFloatingCard from '../ui/AuroraFloatingCard';
const ExamAnalysis = () => {
  // State for selected grade level and class
  const [selectedGrade, setSelectedGrade] = useState('8');
  const [selectedClass, setSelectedClass] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOption, setSortOption] = useState('net-high-to-low');
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  // Mock data for classes
  const classData = {
    '8': [{
      id: '8A',
      name: '8-A',
      students: 21,
      totalNet: 56,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 13,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 13,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 18,
        total: 20,
        color: '#10b981'
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        score: 9,
        total: 10,
        color: '#f97316'
      }, {
        name: 'DİN KÜLTÜRÜ',
        score: 8,
        total: 10,
        color: '#4338ca'
      }, {
        name: 'İNGİLİZCE',
        score: 6,
        total: 10,
        color: '#a855f7'
      }]
    }, {
      id: '8B',
      name: '8-B',
      students: 29,
      totalNet: 51,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 19,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 16,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 16,
        total: 20,
        color: '#10b981'
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        score: 7,
        total: 10,
        color: '#f97316'
      }, {
        name: 'DİN KÜLTÜRÜ',
        score: 8,
        total: 10,
        color: '#4338ca'
      }, {
        name: 'İNGİLİZCE',
        score: 9,
        total: 10,
        color: '#a855f7'
      }]
    }, {
      id: '8C',
      name: '8-C',
      students: 29,
      totalNet: 55,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 13,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 17,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 12,
        total: 20,
        color: '#10b981'
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        score: 8,
        total: 10,
        color: '#f97316'
      }, {
        name: 'DİN KÜLTÜRÜ',
        score: 6,
        total: 10,
        color: '#4338ca'
      }, {
        name: 'İNGİLİZCE',
        score: 6,
        total: 10,
        color: '#a855f7'
      }]
    }, {
      id: '8D',
      name: '8-D',
      students: 29,
      totalNet: 57,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 13,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 14,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 17,
        total: 20,
        color: '#10b981'
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        score: 8,
        total: 10,
        color: '#f97316'
      }, {
        name: 'DİN KÜLTÜRÜ',
        score: 7,
        total: 10,
        color: '#4338ca'
      }, {
        name: 'İNGİLİZCE',
        score: 9,
        total: 10,
        color: '#a855f7'
      }]
    }],
    '7': [{
      id: '7A',
      name: '7-A',
      students: 25,
      totalNet: 53,
      lastExam: '2024-02-10',
      subjects: [{
        name: 'MATEMATİK',
        score: 12,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 15,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 15,
        total: 20,
        color: '#10b981'
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        score: 7,
        total: 10,
        color: '#f97316'
      }, {
        name: 'DİN KÜLTÜRÜ',
        score: 7,
        total: 10,
        color: '#4338ca'
      }, {
        name: 'İNGİLİZCE',
        score: 7,
        total: 10,
        color: '#a855f7'
      }]
    }, {
      id: '7B',
      name: '7-B',
      students: 27,
      totalNet: 49,
      lastExam: '2024-02-10',
      subjects: [{
        name: 'MATEMATİK',
        score: 11,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 14,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 14,
        total: 20,
        color: '#10b981'
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        score: 6,
        total: 10,
        color: '#f97316'
      }, {
        name: 'DİN KÜLTÜRÜ',
        score: 7,
        total: 10,
        color: '#4338ca'
      }, {
        name: 'İNGİLİZCE',
        score: 8,
        total: 10,
        color: '#a855f7'
      }]
    }],
    '6': [{
      id: '6A',
      name: '6-A',
      students: 26,
      totalNet: 48,
      lastExam: '2024-02-08',
      subjects: [{
        name: 'MATEMATİK',
        score: 10,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 13,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 13,
        total: 20,
        color: '#10b981'
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        score: 6,
        total: 10,
        color: '#f97316'
      }, {
        name: 'DİN KÜLTÜRÜ',
        score: 6,
        total: 10,
        color: '#4338ca'
      }, {
        name: 'İNGİLİZCE',
        score: 7,
        total: 10,
        color: '#a855f7'
      }]
    }],
    '5': [{
      id: '5A',
      name: '5-A',
      students: 24,
      totalNet: 45,
      lastExam: '2024-02-05',
      subjects: [{
        name: 'MATEMATİK',
        score: 10,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 12,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 12,
        total: 20,
        color: '#10b981'
      }, {
        name: 'T.C. İNKILAP TARİHİ',
        score: 5,
        total: 10,
        color: '#f97316'
      }, {
        name: 'DİN KÜLTÜRÜ',
        score: 6,
        total: 10,
        color: '#4338ca'
      }, {
        name: 'İNGİLİZCE',
        score: 7,
        total: 10,
        color: '#a855f7'
      }]
    }]
  };
  // Mock student data for each class
  const studentData = {
    '8A': [{
      id: 1,
      name: 'İrem Yücel',
      number: '04',
      net: 63,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 14,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 14,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 17,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 2,
      name: 'Ayşe Demir',
      number: '08',
      net: 63,
      change: -5,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 12,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 10,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 16,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 3,
      name: 'Canan Kılıç',
      number: '07',
      net: 62,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 12,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 13,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 20,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 4,
      name: 'Ahmet Yılmaz',
      number: '12',
      net: 62,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 11,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 11,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 19,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 5,
      name: 'Yağmur Öztürk',
      number: '15',
      net: 62,
      change: -4,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 13,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 11,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 16,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 6,
      name: 'Rüzgar Yıldız',
      number: '21',
      net: 62,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 10,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 15,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 20,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 7,
      name: 'Mehmet Kaya',
      number: '18',
      net: 60,
      change: 3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 12,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 13,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 15,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 8,
      name: 'Zeynep Şahin',
      number: '23',
      net: 58,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 11,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 12,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 14,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 9,
      name: 'Berk Aydın',
      number: '05',
      net: 57,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 10,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 13,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 13,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 10,
      name: 'Selin Çelik',
      number: '14',
      net: 56,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 10,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 11,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 14,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 11,
      name: 'Burak Koç',
      number: '09',
      net: 55,
      change: -3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 9,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 12,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 13,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 12,
      name: 'Deniz Aksoy',
      number: '10',
      net: 54,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 9,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 11,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 12,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 13,
      name: 'Emir Yavuz',
      number: '17',
      net: 53,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 8,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 11,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 12,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 14,
      name: 'Ece Kara',
      number: '16',
      net: 52,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 8,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 10,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 11,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 15,
      name: 'Mert Aslan',
      number: '01',
      net: 51,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 8,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 9,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 11,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 16,
      name: 'Elif Yıldırım',
      number: '11',
      net: 50,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 7,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 9,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 10,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 17,
      name: 'Kaan Özdemir',
      number: '19',
      net: 49,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 7,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 8,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 10,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 18,
      name: 'Sude Arslan',
      number: '03',
      net: 48,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 7,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 8,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 9,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 19,
      name: 'Arda Doğan',
      number: '06',
      net: 47,
      change: 3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 6,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 8,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 9,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 20,
      name: 'Gizem Tekin',
      number: '13',
      net: 46,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 6,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 7,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 9,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 21,
      name: 'Serkan Yalçın',
      number: '20',
      net: 45,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 6,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 7,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 8,
        total: 20,
        color: '#10b981'
      }]
    }],
    '8B': [{
      id: 1,
      name: 'Kerem Demir',
      number: '01',
      net: 61,
      change: 3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 13,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 12,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 16,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 2,
      name: 'Zeynep Yılmaz',
      number: '02',
      net: 59,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 11,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 13,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 15,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 3,
      name: 'Mehmet Kaya',
      number: '03',
      net: 58,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 10,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 12,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 14,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 4,
      name: 'Ayşe Demir',
      number: '04',
      net: 57,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 9,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 11,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 13,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 5,
      name: 'Burak Koç',
      number: '05',
      net: 56,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 8,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 10,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 12,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 6,
      name: 'Emir Yavuz',
      number: '06',
      net: 55,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 7,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 9,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 11,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 7,
      name: 'Ece Kara',
      number: '07',
      net: 54,
      change: -3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 6,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 8,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 10,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 8,
      name: 'Mert Aslan',
      number: '08',
      net: 53,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 5,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 7,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 9,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 9,
      name: 'Elif Yıldırım',
      number: '09',
      net: 52,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 4,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 6,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 8,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 10,
      name: 'Kaan Özdemir',
      number: '10',
      net: 51,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 3,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 5,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 7,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 11,
      name: 'Sude Arslan',
      number: '11',
      net: 50,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 2,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 4,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 6,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 12,
      name: 'Arda Doğan',
      number: '12',
      net: 49,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 1,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 3,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 5,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 13,
      name: 'Gizem Tekin',
      number: '13',
      net: 48,
      change: -3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 0,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 2,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 4,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 14,
      name: 'Serkan Yalçın',
      number: '14',
      net: 47,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 0,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 1,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 3,
        total: 20,
        color: '#10b981'
      }]
    }],
    '8C': [{
      id: 1,
      name: 'İrem Yücel',
      number: '01',
      net: 59,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 12,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 14,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 16,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 2,
      name: 'Ayşe Demir',
      number: '02',
      net: 58,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 11,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 13,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 15,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 3,
      name: 'Canan Kılıç',
      number: '03',
      net: 57,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 10,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 12,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 14,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 4,
      name: 'Ahmet Yılmaz',
      number: '04',
      net: 56,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 9,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 11,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 13,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 5,
      name: 'Yağmur Öztürk',
      number: '05',
      net: 55,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 8,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 10,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 12,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 6,
      name: 'Rüzgar Yıldız',
      number: '06',
      net: 54,
      change: -3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 7,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 9,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 11,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 7,
      name: 'Mehmet Kaya',
      number: '07',
      net: 53,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 6,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 8,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 10,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 8,
      name: 'Zeynep Şahin',
      number: '08',
      net: 52,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 5,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 7,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 9,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 9,
      name: 'Berk Aydın',
      number: '09',
      net: 51,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 4,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 6,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 8,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 10,
      name: 'Selin Çelik',
      number: '10',
      net: 50,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 3,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 5,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 7,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 11,
      name: 'Burak Koç',
      number: '11',
      net: 49,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 2,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 4,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 6,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 12,
      name: 'Deniz Aksoy',
      number: '12',
      net: 48,
      change: -3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 1,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 3,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 5,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 13,
      name: 'Emir Yavuz',
      number: '13',
      net: 47,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 0,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 2,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 4,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 14,
      name: 'Ece Kara',
      number: '14',
      net: 46,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 0,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 1,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 3,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 15,
      name: 'Mert Aslan',
      number: '15',
      net: 45,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 0,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 0,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 2,
        total: 20,
        color: '#10b981'
      }]
    }],
    '8D': [{
      id: 1,
      name: 'İrem Yücel',
      number: '01',
      net: 58,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 13,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 14,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 17,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 2,
      name: 'Ayşe Demir',
      number: '02',
      net: 57,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 12,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 13,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 16,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 3,
      name: 'Canan Kılıç',
      number: '03',
      net: 56,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 11,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 12,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 15,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 4,
      name: 'Ahmet Yılmaz',
      number: '04',
      net: 55,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 10,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 11,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 14,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 5,
      name: 'Yağmur Öztürk',
      number: '05',
      net: 54,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 9,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 10,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 13,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 6,
      name: 'Rüzgar Yıldız',
      number: '06',
      net: 53,
      change: -3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 8,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 9,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 12,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 7,
      name: 'Mehmet Kaya',
      number: '07',
      net: 52,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 7,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 8,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 11,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 8,
      name: 'Zeynep Şahin',
      number: '08',
      net: 51,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 6,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 7,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 10,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 9,
      name: 'Berk Aydın',
      number: '09',
      net: 50,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 5,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 6,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 9,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 10,
      name: 'Selin Çelik',
      number: '10',
      net: 49,
      change: -2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 4,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 5,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 8,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 11,
      name: 'Burak Koç',
      number: '11',
      net: 48,
      change: 1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 3,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 4,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 7,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 12,
      name: 'Deniz Aksoy',
      number: '12',
      net: 47,
      change: -3,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 2,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 3,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 6,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 13,
      name: 'Emir Yavuz',
      number: '13',
      net: 46,
      change: 0,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 1,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 2,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 5,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 14,
      name: 'Ece Kara',
      number: '14',
      net: 45,
      change: -1,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 0,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 1,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 4,
        total: 20,
        color: '#10b981'
      }]
    }, {
      id: 15,
      name: 'Mert Aslan',
      number: '15',
      net: 44,
      change: 2,
      lastExam: '2024-02-15',
      subjects: [{
        name: 'MATEMATİK',
        score: 0,
        total: 20,
        color: '#3b82f6'
      }, {
        name: 'TÜRKÇE',
        score: 0,
        total: 20,
        color: '#ef4444'
      }, {
        name: 'FEN BİLİMLERİ',
        score: 3,
        total: 20,
        color: '#10b981'
      }]
    }]
  };
  // Generate mock data for all classes if not already defined
  useEffect(() => {
    const allClasses = Object.values(classData).flat();
    allClasses.forEach(classInfo => {
      if (!studentData[classInfo.id]) {
        const students = [];
        for (let i = 1; i <= classInfo.students; i++) {
          students.push({
            id: i,
            name: `Öğrenci ${i}`,
            number: i < 10 ? `0${i}` : `${i}`,
            net: Math.floor(Math.random() * 20) + 40,
            change: Math.floor(Math.random() * 10) - 5,
            lastExam: classInfo.lastExam,
            subjects: [{
              name: 'MATEMATİK',
              score: Math.floor(Math.random() * 10) + 5,
              total: 20,
              color: '#3b82f6'
            }, {
              name: 'TÜRKÇE',
              score: Math.floor(Math.random() * 10) + 5,
              total: 20,
              color: '#ef4444'
            }, {
              name: 'FEN BİLİMLERİ',
              score: Math.floor(Math.random() * 10) + 5,
              total: 20,
              color: '#10b981'
            }]
          });
        }
        studentData[classInfo.id] = students;
      }
    });
  }, []);
  // Format date
  const formatDate = dateStr => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };
  // Get classes for selected grade
  const getClassesForGrade = grade => {
    return classData[grade] || [];
  };
  // Get filtered and sorted students for selected class
  const getFilteredStudents = () => {
    if (!selectedClass) return [];
    const students = studentData[selectedClass.id] || [];
    // Filter by search query
    let filtered = students;
    if (searchQuery) {
      filtered = students.filter(student => student.name.toLowerCase().includes(searchQuery.toLowerCase()) || student.number.includes(searchQuery));
    }
    // Sort based on selected option
    switch (sortOption) {
      case 'net-high-to-low':
        return [...filtered].sort((a, b) => b.net - a.net);
      case 'net-low-to-high':
        return [...filtered].sort((a, b) => a.net - b.net);
      case 'name-a-to-z':
        return [...filtered].sort((a, b) => a.name.localeCompare(b.name));
      case 'name-z-to-a':
        return [...filtered].sort((a, b) => b.name.localeCompare(a.name));
      case 'number':
        return [...filtered].sort((a, b) => a.number.localeCompare(b.number));
      default:
        return filtered;
    }
  };
  // Get initial letter for student avatar
  const getInitial = name => {
    return name.charAt(0).toUpperCase();
  };
  // Handle class selection
  const handleClassClick = classInfo => {
    setSelectedClass(classInfo);
  };
  // Go back to class list
  const handleBackToClassList = () => {
    setSelectedClass(null);
    setSearchQuery('');
  };
  return <div className="space-y-6 bg-[#0D1117] min-h-screen" data-id="element-347">
      {/* Header with icon */}
      <div className="flex items-center gap-3 mb-6" data-id="element-348">
        <BookOpen className="w-8 h-8 text-blue-400" data-id="element-349" />
        <h1 className="text-2xl font-bold text-white" data-id="element-350">Sınav Analizleri</h1>
      </div>
      {selectedClass ?
    // Student Analysis View
    <>
          {/* Header with back button */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6" data-id="element-351">
            <div data-id="element-352">
              <button onClick={handleBackToClassList} className="flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-2 transition-colors" data-id="element-353">
                <ArrowLeft size={18} data-id="element-354" />
                <span data-id="element-355">Sınıf Listesi</span>
              </button>
              <h2 className="text-xl font-bold text-white" data-id="element-356">
                {selectedClass.name} - Öğrenci Analizleri
              </h2>
              <p className="text-gray-400" data-id="element-357">
                {selectedClass.students} Öğrenci • Sınıf Ort:{' '}
                {selectedClass.totalNet} net
              </p>
            </div>
            {/* Search and Sort Controls */}
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto" data-id="element-358">
              {/* Search */}
              <div className="relative w-full sm:w-64" data-id="element-359">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-360" />
                <input type="text" placeholder="Öğrenci ara..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-gray-800/50 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-361" />
              </div>
              {/* Sort Dropdown */}
              <div className="relative" data-id="element-362">
                <button onClick={() => setShowSortDropdown(!showSortDropdown)} className="w-full sm:w-auto flex items-center justify-between gap-2 px-4 py-2 bg-gray-800/50 border border-purple-500/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-363">
                  <span data-id="element-364">
                    {sortOption === 'net-high-to-low' ? 'Net (Yüksek → Alçak)' : sortOption === 'net-low-to-high' ? 'Net (Alçak → Yüksek)' : sortOption === 'name-a-to-z' ? 'İsim (A → Z)' : sortOption === 'name-z-to-a' ? 'İsim (Z → A)' : 'Numara'}
                  </span>
                  <ChevronDown size={18} data-id="element-365" />
                </button>
                {showSortDropdown && <div className="absolute right-0 mt-2 z-10 w-48 bg-gray-900 border border-gray-700 rounded-lg shadow-xl py-2" data-id="element-366">
                    <button onClick={() => {
                setSortOption('net-high-to-low');
                setShowSortDropdown(false);
              }} className="w-full text-left px-4 py-2 text-white hover:bg-gray-800" data-id="element-367">
                      Net (Yüksek → Alçak)
                    </button>
                    <button onClick={() => {
                setSortOption('net-low-to-high');
                setShowSortDropdown(false);
              }} className="w-full text-left px-4 py-2 text-white hover:bg-gray-800" data-id="element-368">
                      Net (Alçak → Yüksek)
                    </button>
                    <button onClick={() => {
                setSortOption('name-a-to-z');
                setShowSortDropdown(false);
              }} className="w-full text-left px-4 py-2 text-white hover:bg-gray-800" data-id="element-369">
                      İsim (A → Z)
                    </button>
                    <button onClick={() => {
                setSortOption('name-z-to-a');
                setShowSortDropdown(false);
              }} className="w-full text-left px-4 py-2 text-white hover:bg-gray-800" data-id="element-370">
                      İsim (Z → A)
                    </button>
                    <button onClick={() => {
                setSortOption('number');
                setShowSortDropdown(false);
              }} className="w-full text-left px-4 py-2 text-white hover:bg-gray-800" data-id="element-371">
                      Numara
                    </button>
                  </div>}
              </div>
            </div>
          </div>
          {/* Student List */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-372">
            {getFilteredStudents().map(student => <div key={student.id} className="relative" data-id="element-373">
                <AuroraFloatingCard data-id="element-374">
                  <div className="flex items-center justify-between mb-4" data-id="element-375">
                    <div className="flex items-center gap-3" data-id="element-376">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center" data-id="element-377">
                        <span className="text-white font-bold" data-id="element-378">
                          {getInitial(student.name)}
                        </span>
                      </div>
                      <div data-id="element-379">
                        <h3 className="text-lg font-medium text-white" data-id="element-380">
                          {student.name}
                        </h3>
                        <p className="text-sm text-gray-400" data-id="element-381">
                          No: {student.number}
                        </p>
                      </div>
                    </div>
                    <div className="text-2xl font-bold text-green-400" data-id="element-382">
                      {student.net}
                      <span className="text-sm ml-1" data-id="element-383">net</span>
                    </div>
                  </div>
                  {/* Subject Scores */}
                  <div className="space-y-2 mb-4" data-id="element-384">
                    {student.subjects.map((subject, index) => <div key={index} className="flex items-center justify-between" data-id="element-385">
                        <div className="flex items-center gap-2" data-id="element-386">
                          <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: subject.color
                  }} data-id="element-387"></div>
                          <span className="text-sm text-white" data-id="element-388">
                            {subject.name}
                          </span>
                        </div>
                        <span className="text-sm font-medium text-white" data-id="element-389">
                          {subject.score}/{subject.total}
                        </span>
                      </div>)}
                    <div className="text-sm text-gray-400 text-right" data-id="element-390">
                      +3 ders daha
                    </div>
                  </div>
                  {/* Last Exam Info */}
                  <div className="flex items-center justify-between pt-3 border-t border-gray-800" data-id="element-391">
                    <div className="text-xs text-gray-400" data-id="element-392">
                      Son Sınav: {formatDate(student.lastExam)}
                    </div>
                    <div className={`flex items-center gap-1 text-sm font-medium ${student.change > 0 ? 'text-green-500' : student.change < 0 ? 'text-red-500' : 'text-gray-400'}`} data-id="element-393">
                      {student.change > 0 ? <>
                          <TrendingUp size={16} data-id="element-394" />
                          <span data-id="element-395">+{student.change}</span>
                        </> : student.change < 0 ? <>
                          <TrendingDown size={16} data-id="element-396" />
                          <span data-id="element-397">{student.change}</span>
                        </> : <span data-id="element-398">0</span>}
                    </div>
                  </div>
                </AuroraFloatingCard>
              </div>)}
          </div>
        </> :
    // Class List View
    <>
          {/* Grade selection tabs */}
          <div className="flex gap-2 mb-8" data-id="element-399">
            {['8', '7', '6', '5'].map(grade => <button key={grade} onClick={() => setSelectedGrade(grade)} className={`px-6 py-3 rounded-lg transition-all ${selectedGrade === grade ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium' : 'bg-[#161B22] text-gray-400 hover:bg-[#1F2937] hover:text-white'}`} data-id="element-400">
                {grade}. Sınıf
              </button>)}
          </div>
          {/* Class cards grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-401">
            {getClassesForGrade(selectedGrade).map(classInfo => <div key={classInfo.id} className="relative" data-id="element-402">
                <AuroraFloatingCard className="cursor-pointer hover:shadow-lg transition-shadow" onClick={() => handleClassClick(classInfo)} data-id="element-403">
                  <div className="flex items-center justify-between mb-4" data-id="element-404">
                    <div className="flex items-center gap-3" data-id="element-405">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center" data-id="element-406">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-407">
                          <path d="M18 8a6 6 0 0 0-6-6 6 6 0 0 0-6 6 6 6 0 0 0 6 6 6 6 0 0 0 6-6z" data-id="element-408"></path>
                          <path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" data-id="element-409"></path>
                        </svg>
                      </div>
                      <div data-id="element-410">
                        <h3 className="text-xl font-bold text-white" data-id="element-411">
                          {classInfo.name}
                        </h3>
                        <p className="text-sm text-gray-400" data-id="element-412">
                          {classInfo.students} öğrenci
                        </p>
                      </div>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400" data-id="element-413" />
                  </div>
                  <div className="mb-4" data-id="element-414">
                    <div className="text-sm text-gray-400" data-id="element-415">
                      Sınıf Ortalaması
                    </div>
                    <div className="text-4xl font-bold text-green-400" data-id="element-416">
                      {classInfo.totalNet} <span className="text-lg" data-id="element-417">net</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mb-6" data-id="element-418">
                    <div className="w-40 h-40" data-id="element-419">
                      <ResponsiveContainer width="100%" height="100%" data-id="element-420">
                        <PieChart data-id="element-421">
                          <Pie data={classInfo.subjects} cx="50%" cy="50%" innerRadius={30} outerRadius={60} paddingAngle={2} dataKey="score" data-id="element-422">
                            {classInfo.subjects.map((subject, index) => <Cell key={`cell-${index}`} fill={subject.color} data-id="element-423" />)}
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                  <div className="space-y-2" data-id="element-424">
                    {classInfo.subjects.map((subject, index) => <div key={index} className="flex items-center justify-between" data-id="element-425">
                        <div className="flex items-center gap-2" data-id="element-426">
                          <div className="w-3 h-3 rounded-full" style={{
                    backgroundColor: subject.color
                  }} data-id="element-427"></div>
                          <span className="text-sm text-white" data-id="element-428">
                            {subject.name}
                          </span>
                        </div>
                        <span className="text-sm font-medium text-white" data-id="element-429">
                          {subject.score}/{subject.total}
                        </span>
                      </div>)}
                  </div>
                  <div className="mt-6 pt-4 border-t border-gray-800" data-id="element-430">
                    <div className="text-xs text-gray-400" data-id="element-431">
                      Son Sınav: {formatDate(classInfo.lastExam)}
                    </div>
                  </div>
                </AuroraFloatingCard>
              </div>)}
          </div>
        </>}
    </div>;
};
export default ExamAnalysis;